import * as React from "react";
import LIcon from "./LIcon";
import LPressable from "./LPressable";

interface TickBoxProps {
  disabled?: boolean;
  disabledOpacity?: number;
  on: boolean;
  title: string;
  toggle?: (val: boolean) => void;
  variant?: "playlist" | "round" | "square";
}

const TickBox = ({
  disabled,
  disabledOpacity,
  on,
  title,
  toggle,
  variant,
}: TickBoxProps) => {
  const round = variant === "round";
  const colors = on
    ? {
        fill: round ? "artistGreen" : "white",
        stroke: round ? "artistGreen" : "white",
        check: round ? "black" : "slate",
      }
    : {
        fill: "transparent",
        stroke: "greyText",
        check: "transparent",
      };
  const icon =
    variant === "playlist" ? (
      on ? (
        <LIcon
          colors={{ fill: "#3880E4", stroke: "#3880E4", check: "black" }}
          disabledOpacity={disabledOpacity}
          enabled={!disabled}
          mr="s1"
          name="round_checkbox"
          size={24}
        />
      ) : (
        <LIcon
          colors={{ color: "white" }}
          disabledOpacity={disabledOpacity}
          enabled={!disabled}
          mr="s1"
          name="round_plus"
          size={24}
        />
      )
    ) : (
      <LIcon
        disabledOpacity={disabledOpacity}
        enabled={!disabled}
        mr="s1"
        name={round ? "round_checkbox" : "checkbox"}
        colors={colors}
        size={24}
      />
    );

  return (
    <LPressable
      disabled={disabled}
      onPress={() => toggle?.(!on)}
      sentryEventName={`tick_box_${title}_${on ? "on" : "off"}`}
      style={{
        alignItems: "center",
        flexDirection: "row",
        justifyContent: "center",
      }}
    >
      {icon}
    </LPressable>
  );
};

export default TickBox;
